import React from "react";
import ComingSoon from "../../components/ComingSoon";

export default function PrivacyPolicy() {
  return <ComingSoon title="Privacy Policy" />;
}
